/**
 * 级联选择器，滚动加载更多数据
 * @description 用于 ElementUI 的级联选择器，滚动到底部加载更多数据
 * @param {Array|String} value - 加载更多数据的回调函数
 */
export default {
	name: "cascaderScroll",
	directive: {
		inserted(el, binding) {
			const cascaderDom = el.querySelector(
				".el-cascader__dropdown .el-cascader-menu__wrap" // 滚动条所在元素
			);

			if (cascaderDom) {
				let currentScroll = 0;
				let isLoading = false;

				const observer = new MutationObserver(() => {
					if (isLoading) {
						// 恢复滚动条位置
						cascaderDom.scrollTop = currentScroll;
						isLoading = false;
					}
				});

				observer.observe(cascaderDom, { childList: true, subtree: true });

				cascaderDom.addEventListener("scroll", function () {
					const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;

					if (condition && !isLoading) {
						currentScroll = this.scrollTop;
						isLoading = true;

						binding.value();
					}
				});
			}
		}
	}
};
